class BaseStore {
  constructor(rootStore) {
    this.rootStore = rootStore;

    if (!this.rootStore) throw new Error("rootStore cannot be null");
  }
}

export default BaseStore;



// WEBPACK FOOTER //
// ./src/Core/Stores/BaseStore/index.js